import { render } from "./draft-comments.vue?vue&type=template&id=a4594e80"
import script from "./draft-comments.vue?vue&type=script&lang=js"
export * from "./draft-comments.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__